<template>
    <card>
        <card-header>
            <card-overline>P-Warenausgang</card-overline>
        </card-header>
        <card-content>
            <table class="table table--card table--stripped">
                <thead>
                <tr>
                    <th>Ausgangsdatum</th>
                    <th>Liefermenge</th>
                    <th>Kommentar</th>
                    <th>Lieferschein</th>
                    <th>Versandetikett</th>
                    <th>Operator</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="outgoing in outgoingGoodsProducerTable"
                    :key="outgoing.index">
                    <td>{{ outgoing.created_at_string }}</td>
                    <td>{{ outgoing.amount_string }}</td>
                    <td>{{ outgoing.comment }}</td>
                    <td>
                        <a :href="this.$$route('delivery.outgoing-goods-producer-bill.pdf', {'delivery': outgoing.id})"
                           target="_blank">Lieferschein</a>
                    </td>
                    <td v-if="outgoing.ups_label"><a
                        :href="this.$$route('ups-label.download', {'delivery': outgoing.id})"
                        target="_blank">UPS Label</a></td>
                    <td v-if="!outgoing.ups_label">-</td>
                    <td>{{ outgoing.admin_user.name }}</td>
                    <td>
                        <form-button type="button" class="btn--dense"
                                     @click="deleteDialog = true; deleteRoute = this.$$route('ask-for-quote.delivery.outgoing-goods-producer.delete', {'askForQuote': this.askForQuote, 'delivery': outgoing.id})"
                                     icon="trash-delete-bin-2"/>
                    </td>
                </tr>
                </tbody>
            </table>
            <modal-dialog title="P-Warenausgang löschen" text="Möchten Sie den P-Warenausgang wirklich löschen?" confirm="löschen" v-if="deleteDialog" @closeDialog="deleteDialog = false;" @confirmDialog="deleteMethod" />
        </card-content>
        <card-content>
            <form-button class="btn--block" color="secondary"
                         @click="outgoingGoodsProducerModal = !outgoingGoodsProducerModal"
                         icon="package-box-arrow-up" :disabled="disabledTab || ! hasProducerComplaints">neuer Warenausgang
            </form-button>
            <outgoing-goods-producer-modal :ask-for-quote="askForQuote"
                                           v-if="outgoingGoodsProducerModal"
                                           :admin-users="adminUsers"
                                           @closeDialog="outgoingGoodsProducerModal = false"/>
        </card-content>
    </card>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormButton from '@partfactory/Shared/Form/FormButton';
import OutgoingGoodsProducerModal from '@partfactory/Pages/Admin/AskForQuote/Modals/OutgoingGoodsProducerModal';
import ModalDialog from '@partfactory/Shared/Modal/ModalDialog';
export default {
    name: 'OutgoingGoodsProducer',
    components: {ModalDialog, OutgoingGoodsProducerModal, FormButton, CardContent, CardOverline, CardHeader, Card},
    props: {
        askForQuote: Object,
        adminUsers: Object,
    },
    data() {
        return {
            outgoingGoodsProducerModal: false,
            deleteDialog: false,
            deleteRoute: null,
        };
    },
    computed: {
        maxOutgoingQty() {
            let maxOutgoingQty = 0;
            this.askForQuote?.incoming_goods_client?.forEach((outgoing) => {
                maxOutgoingQty += outgoing.amount;
            });
            return maxOutgoingQty;
        },
        outgoingGoodsProducerTable() {
            let outgoingGoodsProducer = this.askForQuote?.outgoing_goods_producer;
            outgoingGoodsProducer.forEach(outgoingGoodsProducer => {
                outgoingGoodsProducer.created_at_string = this.$moment(outgoingGoodsProducer.created_at).format('DD.MM.YYYY');
                outgoingGoodsProducer.amount_string = outgoingGoodsProducer.amount + ' von ' + this.maxOutgoingQty;

                return outgoingGoodsProducer;
            });

            return outgoingGoodsProducer;
        },
        disabledTab() {
            return this.$disabledTab(this.askForQuote.status, 99);
        },
        hasProducerComplaints() {
            return this.askForQuote?.producer_complaints.length > 0;
        },
    },
    methods: {
        deleteMethod() {
            this.$inertia.delete(this.deleteRoute);
            this.deleteRoute = null;
            this.deleteDialog = false;
        },
    },
};
</script>
